import React, { useEffect, useMemo, useState } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import InputForm from "../../../../../components/input/input-form.jsx";
import PassageLabelsCards from "./components/passage-labels-cards.jsx";
import LabelsWithMorePassages from "./components/labels-with-more-passages.jsx";
import UsersLabelsWithMorePassage from "./components/users-labels-with-more-passage.jsx";
import LabelsPerDate from "./components/labels-per-date.jsx";

const ReportContent = ({ data, collapsed }) => {
  return (
    <>
      <PassageLabelsCards key={`card-${collapsed}`} passagesLabelTotal={data?.totalPassagesLabels} passagesTotal={data?.totalLabels} passageLabelsList={data?.passageLabelList}/>
      <LabelsWithMorePassages key={`labels-with-more-passages-${collapsed}`} data={data?.labelsWithMorePassages}/>
      <UsersLabelsWithMorePassage key={`users-labels-with-more-passages-${collapsed}`} data={data?.usersLabelsWithMorePassages}/>
      <LabelsPerDate key={`labels-per-date-${collapsed}`} data={data?.labelsPerDate} />
      <div id="chart-tables"></div>
    </>
  );
};

export default ReportContent;